<div
    #container
    class="flex flex-row justify-end w-full max-h-8 items-center">
    @for (filter of activeFiltersInContentBar(); track filter.id) {
        <app-active-filter-item [filter]="filter" />
    }

    @if (activeFiltersInDropdown().length) {
        <app-active-filter-dropdown
            [activeFiltersInDropdown]="activeFiltersInDropdown()"
            [currentWidth]="currentWidth()" />
    }
</div>
